import {AxiosResponse} from 'axios'
import {HttpInstance} from '../createHttpInstance'
import {Paginated, StaffRequest, ProgramAreasResponse} from './types'

export interface ProgramAreas<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const programAreas: ProgramAreas<
  StaffRequest,
  Paginated<ProgramAreasResponse>
> = (http, params) => {
  const {ClientID, PageNumber, PageSize} = params

  const path = '/v0/staff/programareas'

  const queryParams = []
  if (ClientID !== undefined) {
    queryParams.push(`clientid=${ClientID}`)
  }
  if (PageNumber !== undefined) {
    queryParams.push(`pagenumber=${PageNumber}`)
  }
  if (PageSize !== undefined) {
    queryParams.push(`pagesize=${PageSize}`)
  }
  const query = `?${queryParams.join('&')}`

  return http.request<Paginated<ProgramAreasResponse>>({
    method: 'GET',
    url: `${path}${query}`,
  })
}
